/**
 * Common texts - what is CamAPS FX
 */
export const whatIsCamAPSFX = {

    linkFindOutMore: 'Få mere at vide',
    body:
        '<h2>Hvad er CamAPS FX?</h2> <p> CamAPS FX er en app til styring af glukoseniveauer hos mennesker med type 1-diabetes, via et avanceret adaptivt lukket hybridsystem. </p>'
};

/**
 * Common texts - what is CamAPS FX
 */
export const userReviewsIntro = {
    linkMoreReviews: 'Flere fortællinger',
    readMore: 'Læs mere',
    header:
        'Brugerhistorier',
    text:
        'Rigtige mennesker. Rigtige erfaringer.'
};